import { memo } from 'react';
import { Typography } from '../../../components/typography/typography';
import classNames from 'classnames';

interface AssignedQuantityProps {
  isEditing: boolean;
  quantity?: number;
  isRental: boolean;
  qtyAvailable?: number;
  stock?: number;
  showQtyWarning?: boolean;
  className?: string;
}

export const AssignedQuantity = memo<AssignedQuantityProps>(
  ({ isEditing, quantity, isRental, qtyAvailable, stock, showQtyWarning, className }) => {
    const renderText = () => {
      if (!isEditing) {
        const actualQuantity = quantity || 0;
        return <>{`Qty: ${actualQuantity}`}</>;
      }

      const actualQtyAvailable = (qtyAvailable && Number(qtyAvailable).toFixed(2)) || Number(0).toFixed(2);
      const actualStock = (stock && Number(stock).toFixed(2)) || 0;

      return <>{`${actualQtyAvailable} ${actualStock && isRental ? `of ${actualStock}` : ''} units available`}</>;
    };

    return (
      <div className="flex flex-col gap-2">
        <Typography
          type="text-sm"
          weight="regular"
          className={classNames(className)}
          dataCy="assign-unit-qty-available"
        >
          {renderText()}
        </Typography>

        {showQtyWarning && (
          <Typography
            type="text-sm"
            weight="semi-bold"
            className="!text-warning-700 py-4"
            dataCy="assign-unit-exceeded"
          >
            Exceeding available quantity
          </Typography>
        )}
      </div>
    );
  },
);

AssignedQuantity.displayName = 'AssignedQuantity';
